import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import { useWallet } from '../context/WalletContext';
import { useUserData } from '../hooks/useUserData';
import RegisterForm from '../components/register/RegisterForm';
import WalletModal from '../components/wallet/WalletModal';

const Register = () => {
  const { account } = useWallet();
  const [refreshKey, setRefreshKey] = useState(0);
  const user = useUserData(refreshKey);
  const [open, setOpen] = useState(false);

  if (!account) {
    return (
      <Layout>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px 20px' }}>
          <h2 className="text-yellow">Connect Wallet to Register</h2>
          <p className="text-muted" style={{ marginTop: 8 }}>You need a wallet to activate your account.</p>
          <button className="btn btn-primary btn-lg" style={{ marginTop: 18 }} onClick={() => setOpen(true)}>Connect Wallet</button>
        </div>
        <WalletModal open={open} onClose={() => setOpen(false)} />
      </Layout>
    );
  }

  // Only redirect once we've actually loaded data and confirmed registration
  if (user.loaded && user.registered) return <Navigate to="/dashboard" replace />;

  return (
    <Layout>
      <div className="page-header">
        <div className="page-title">Register</div>
        <div className="page-subtitle">Activate Genesis to start earning.</div>
      </div>

      <RegisterForm onRegistered={() => setRefreshKey((k) => k + 1)} />
    </Layout>
  );
};

export default Register;
